import { createContext, useContext, useMemo, useState } from 'react';

export interface GridState {
  draggedWidgetId: string;
  setDraggedWidgetId: (val: string) => void;
}

const WidgetDragStateContext = createContext<GridState | null>(null);

export const WidgetDragStateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [draggedWidgetId, setDraggedWidgetId] = useState<string>(null);

  const state = useMemo(() => {
    return {
      draggedWidgetId,
      setDraggedWidgetId,
    };
  }, [draggedWidgetId, setDraggedWidgetId]);
  return (
    <WidgetDragStateContext.Provider value={state}>
      {children}
    </WidgetDragStateContext.Provider>
  );
};

export const useWidgetDragState = () => {
  const state = useContext(WidgetDragStateContext);
  if (!state) {
    throw new Error(
      'state is undefined. Make sure you wrapped your component with <WidgetDragStateProvider />'
    );
  }
  return state;
};
